import { useEffect, useState } from "react"
import ActivityCardItem from "./ActivityCardItem"
import SliderNextArrow from "@modules/Common/components/SliderNextArrow"
import SliderPrevArrow from "@modules/Common/components/SliderPrevArrow"
import { ActivitySliderWrapper, StyledBox, StyledBoxHeader, StyledOverlay } from "../styled/Activity"
import { FindStudentManyActivityInput, StudentActivitiesQuery, useStudentActivitiesQuery } from "@generated/graphql"

interface Props {
  title: string
  description: string
  showButton?: "play" | "live"
  where: FindStudentManyActivityInput
}

export default function DynamicActivitiesList({ title, description, where, showButton }: Props) {

  const [skip, setSkip] = useState(0)
  const [take, setTake] = useState(5)
  const [isReachingEnd, setIsReachingEnd] = useState<boolean>(false)
  const [activities, setActivities] = useState<StudentActivitiesQuery["studentActivities"]>([])
  const { data: activitiesData, loading: activitiesDataLoading, error: activitiesDataError } = useStudentActivitiesQuery({
    variables: {
      where: where,
      skip: skip,
      take: take
    },
    skip: isReachingEnd,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-and-network"
  })


  const settings = {
    infinite: false,
    speed: 500,
    nextArrow: <SliderNextArrow />,
    prevArrow: <SliderPrevArrow />,
    slidesToShow: 4,
    slidesToScroll: 1,
    swipeToSlide: true,
    afterChange: function (index: number) {
      if (isReachingEnd === false && index === activities.length - 4) {
        setSkip(activities.length)
        setTake(4)
      }
    },
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 625,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
        },
      },
    ],
  }

  useEffect(() => {
    if (activitiesDataLoading === false && activitiesData && activitiesData?.studentActivities) {
      if (activitiesData?.studentActivities.length < take) {
        setIsReachingEnd(true)
      }
      setActivities([...activities, ...activitiesData.studentActivities])
    }
  }, [activitiesDataLoading, activitiesData])

  return (activities.length > 0 ? <>
    <StyledBox>
      <StyledBoxHeader>{title}</StyledBoxHeader>
      <img src="/assets/svg/activities-heading-big.svg" />
    </StyledBox>
    <StyledOverlay>
      <div style={{ fontWeight: 600, fontSize: "1.2rem" }} dangerouslySetInnerHTML={{ __html: description }} />
      <ActivitySliderWrapper {...settings}>
        {activities.map((activity) => <ActivityCardItem showButton={showButton} key={activity.id} item={activity} />)}
      </ActivitySliderWrapper>
    </StyledOverlay>
  </> : null)
}
